module.exports = __webpack_public_path__ + "static/media/yelp_logo.ca4395e4.svg";